/**
 * Состояние асинхронной задачи на auth-сервисе.
 * Зеркалит prisma-модель Job (см. VeilStaff.AIHR.Auth/prisma/schema.prisma).
 */
export type JobStatus = 'PENDING' | 'PROCESSING' | 'DONE' | 'FAILED';

export interface JobState<TResult = unknown, TPayload = unknown> {
  id: string;
  userId: string;
  type: string;
  status: JobStatus;
  payload: TPayload;
  result: TResult | null;
  error: string | null;
  refId: string | null;
  attempts: number;
  createdAt: string;
  updatedAt: string;
}

/** WS-события, которые шлёт WebsocketGateway по завершении/падении job. */
export const JOB_TYPES = {
  INTERVIEW_SCORES: 'interview.scores',
  EXTRACT_SKILLS: 'extract.skills',
} as const;

export const wsJobReadyEvent = (jobType: string) => `${jobType}.ready`;
export const wsJobFailedEvent = (jobType: string) => `${jobType}.failed`;

export interface InterviewScoresReadyPayload {
  jobId: string;
  interviewId: string;
  result: unknown; // Interview (с заполненными result/report)
}

export interface InterviewScoresFailedPayload {
  jobId: string;
  interviewId: string;
  error: string;
}

export interface ExtractSkillsReadyPayload {
  jobId: string;
  extractInterviewId: string;
  result: { results?: unknown; [k: string]: unknown }; // ExtractInterview из БД
}

export interface ExtractSkillsFailedPayload {
  jobId: string;
  extractInterviewId: string;
  error: string;
}
